const formatTimeZoneDateString = (date) => {
    if (!date) return 'null';

    const d = new Date(date); // UTC → local timezone

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export default formatTimeZoneDateString;